import React from 'react';
import '../../styles/loader.css'

const KshemaLoader = () => {
  return (
    <>
        <div className="loading-page">
          <img
            src={require('../../assets/images/loading.gif')}
            style={{ height: '100px', width: '100px' }}
            alt='Loading...'
          />
        </div>
  
    </>
  )
}

export default KshemaLoader
